// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"6c8d9033","164":"62ad7576","357":"9e8f1a82","420":"97a5e526","635":"6ff888bd","728":"0b72da06","840":"734e6357","883":"21373631"}[chunkId] + ".chunk.js";
};